import React from 'react';
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {RoutePaths} from "../config/routeConstants";
import LicenseActivation from "../pages/auth/LicenseActivation";
import {LicenseStatus} from "../models/license.models";
import {useLicenseValidation} from "../contexts/LicenseProvider";

const LicenseRequiredGuard = () => {
    const { status, revalidateLicense } = useLicenseValidation();
    const { isVerifying, isAuthenticated, isAdmin} = useAuth();
    const location = useLocation();

    if (isVerifying) {
        return <LoadingSpinner/>;
    }

    if (!isAuthenticated) {
        return <Navigate to={RoutePaths.Login} replace state={{from: location}} />;
    }

    if (status === LicenseStatus.CHECKING) {
        return <LoadingSpinner/>;
    }

    if (status === LicenseStatus.ERROR) {
        return <LicenseActivation error onRetry={() => revalidateLicense()} />;
    }

    if (status === LicenseStatus.INVALID) {
        return <Navigate to={isAdmin ? RoutePaths.LicenseActivation : RoutePaths.LicensePending} replace />;
    }

    return <Outlet />;
};

export default LicenseRequiredGuard;